module.exports = __webpack_public_path__ + "assets/img/home-bj.ce833357.png";